import "../../App.css";
import { Routes, Route } from "react-router-dom";
import Nopage from "../Nopage/Nopage";
import UserForgetPassword from "./userForgetPassword/userForgetPassword";
import UserSetNewPassword from "./userSetNewPassword/userSetNewPassword";
import UserSignin from "./userSignin/userSignin";
import UserSignUp from "./userSignUp/userSignUp";
import UserVerifyEmail from "./userVerifyEmail/userVerifyEmail";
import UserSignUpStepComplete from "./userSignUpStep3/userSignUpStepComplete";
import UserSigninQuick from "./userSignin/userSigninQuick";

const UserAuthRoutes = () => {
  return (
    <Routes>
      <Route index element={<UserSignin />} />
      <Route path="/signin" element={<UserSignin />} />
      <Route path="/quick-signin" element={<UserSigninQuick />} />
      <Route path="/signup" element={<UserSignUp />} />
      <Route path="/verify-email" element={<UserVerifyEmail />} />
      <Route
        path="/signup-step-complete"
        element={<UserSignUpStepComplete />}
      />
      <Route path="/user-forget-password" element={<UserForgetPassword />} />
      <Route path="/user-setnew-password" element={<UserSetNewPassword />} />
      <Route path="*" element={<Nopage />} />
    </Routes>
  );
};

export default UserAuthRoutes;
